const Chaps = require("./chaps.png");
const Extreme = require("./extreme.png");
const ComingSoon = require("./comingSoon.png");
const packet = require("./25-26PartnershipPacket.pdf");

export { Chaps, Extreme, ComingSoon, packet };